export const stateName = 'packageSizes' as const
